import React from 'react';
import clsx from 'clsx';
import { Tooltip } from 'antd';
import { Icon } from 'shared/components/Icon';
import { ChatMessageArgs, ChatMessageBlockType } from 'sb-lib/types';
import { useAppDispatch } from 'shared/store';
import { sendChatMessage } from 'shared/store/chat-slice';
import './style.less';

type SendInputBlockTypes =
  | ChatMessageBlockType.EMAIL_INPUT
  | ChatMessageBlockType.PHONE_INPUT;

interface SendInputCollectorButtonProps {
  className?: string;
  conversationId: number;
  visitorId: string;
  inputBlockType: SendInputBlockTypes;
}

const NAME = 'SendInputCollectorButton';
export const SendInputCollectorButton: React.FC<SendInputCollectorButtonProps> = ({
  className,
  conversationId,
  visitorId,
  inputBlockType,
}) => {
  const dispatch = useAppDispatch();
  const handleSendMeetingBooker = async () => {
    const message = makeMessageByBlockType[inputBlockType](visitorId, conversationId);
    await dispatch(sendChatMessage(message));
  };
  return (
    <div className={clsx([className, NAME])}>
      <Tooltip title="Ask for email" placement="top">
        <button onClick={handleSendMeetingBooker}>
          <Icon icon="atSignCheckmark" />
        </button>
      </Tooltip>
    </div>
  );
};

const makeEmailMessage = (visitorId: string, conversationId: number): ChatMessageArgs => {
  return {
    visitorId,
    conversationId,
    content: {
      blocks: [
        {
          type: ChatMessageBlockType.EMAIL_INPUT,
          emailInput: null,
        },
      ],
    },
  };
};

const makePhoneMessage = () => {
  throw new Error('makePhoneMessage is not implemented');
};

const makeMessageByBlockType = {
  [ChatMessageBlockType.EMAIL_INPUT]: makeEmailMessage,
  [ChatMessageBlockType.PHONE_INPUT]: makePhoneMessage,
};
